module.exports = __webpack_public_path__ + "media/src/images/graph_exp04-52aa1fe14e4c29f4cc9d5e1d424344dd.png";